import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import { getPermissions, getCompany, getCurrentRole } from 'auth/selectors';
import { getVisibleSubcompanies, getListIsFetching } from 'subcompanies/selectors';
import NoSubcompanies from 'components/layout/NoSubcompanies';
import { deleteSubcompany } from 'subcompanies/actions';
import { addGrowlError, addGrowlSuccess } from 'messages/actions';

import * as Common from 'common/components';
import * as Subcompanies from 'subcompanies/components';
import Subcompany from 'subcompanies/containers/SubcompanyContainer';

class SubcompaniesListContainer extends PureComponent {
  state = { deletingSubcompany: null, isDeleteModalOpen: false };

  handleDelete = (subcompany) => {
    this.setState({
      deletingSubcompany: subcompany,
      isDeleteModalOpen: true,
    });
  };

  handleAcceptDelete = () => {
    this.props
      .deleteSubcompany(this.props.company.id, this.state.deletingSubcompany.id)
      .then(({ value }) => this.props.addGrowlSuccess(value.message))
      .catch((err) => err.code !== 401 && this.props.addGrowlError(err.message));
    this.setState({ deletingSubcompany: null, isDeleteModalOpen: false });
  };

  handleCancelDelete = () => {
    this.setState({ deletingSubcompany: null, isDeleteModalOpen: false });
  };

  renderSubcompanies = () =>
    this.props.subcompanies.map((subcompany) => (
      <Subcompany key={subcompany.id} handleDelete={this.handleDelete} subcompany={subcompany} />
    ));

  render = () => (
    <Common.PageWrapper fluid={true}>
      <Subcompanies.Header
        companyId={this.props.company.id}
        canAdd={this.props.permissions['acl.subcompanies.add']}
      />
      <Subcompanies.DeleteModal
        handleAccept={this.handleAcceptDelete}
        handleClose={this.handleCancelDelete}
        isOpened={this.state.isDeleteModalOpen}
        subcompany={this.state.deletingSubcompany}
      />
      {this.renderSubcompanies()}
      {/* feature/acceso-subcompanias: a user with a list whose subcompanies no
          longer exist. Not for root or the Administrador: for them an empty
          list is a company without subcompanies yet. */}
      {!this.props.isFetching &&
        this.props.subcompanies.length === 0 &&
        !(this.props.role && this.props.role.isAdmin) && <NoSubcompanies />}
    </Common.PageWrapper>
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  permissions: getPermissions(state),
  subcompanies: getVisibleSubcompanies(state),
  isFetching: getListIsFetching(state),
  role: getCurrentRole(state),
});

const mapDispatchToProps = {
  deleteSubcompany,
  addGrowlError,
  addGrowlSuccess,
};

export default connect(mapStateToProps, mapDispatchToProps)(SubcompaniesListContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/subcompanies/containers/SubcompaniesListContainer.js